import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="relative w-full py-14 md:py-20 bg-background-50" id="faq">
      <div className="w-full max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 tracking-tight mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            快速了解开云体育平台的常见疑问
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200 rounded-xl overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 ${
                  openIdx === idx ? 'bg-primary-500 text-background-50 dark:text-foreground-950 rotate-45' : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-60 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}